import * as React from "react";
import { Button, Modal } from "react-bootstrap";
import { List,ListItem } from "material-ui/List";
import Subheader from 'material-ui/Subheader';
import Avatar from 'material-ui/Avatar';
import DownloadFile from 'material-ui/svg-icons/file/cloud-download';
import Divider from 'material-ui/Divider';
import icoXLS from "../../../../../../assets/img/ico-xls.png";

export default class ModalXLSDatosGlosas extends React.Component<ModalXLSDatosGlosasProps, any> {

    render() {
        return(
            <div>
                <Modal show={this.props.showModalXLS} onHide={this.props.closeModalXLS}>
                    <Modal.Header>
                        <Modal.Title>Exportar XLS - Reportes</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        Existen {this.props.reportesXLS} reportes para exportar de las {this.props.totalPaginas} páginas encontradas con el filtro de búsqueda. 
                        Selecciona el reporte que deseas exportar, para así iniciar la descarga. 
                        <List>
                            <Subheader>Listado de reportes</Subheader>
                            {this.listaReportesXLS()}
                        </List>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button className={"btns btns-secondary"} onClick={this.props.closeModalXLS}>Cerrar</Button>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }

    listaReportesXLS() {
        const listaItems = [];
        const maxPaginasXLS = Math.trunc(this.props.maxRegistrosXLS/this.props.tamanoPaginaFiltro);
        for (let i = 0; i < this.props.reportesXLS; i++) {
            listaItems.push(
                <div key={i}>
                    <Divider />
                    <ListItem
                        primaryText={"Descargar reporte de inconsistencias #" + (i+1)}
                        secondaryText={`Informe de las páginas  ${ 1+(1*((maxPaginasXLS)*(i)))} a ${i === (this.props.reportesXLS-1) ? (this.props.totalPaginas) :  maxPaginasXLS*(i+1)}`}
                        leftAvatar={<Avatar src={icoXLS} size={40}/>}
                        rightIcon={<DownloadFile/>}
                        onClick={this.props.generarXLS.bind(this, i)}
                    />  
                </div>
            );
        }
        return <List>{listaItems}</List>;
    }
} 

interface  ModalXLSDatosGlosasProps {
    totalGlosasConsulta: number,
    reportesXLS: number,
    showModalXLS: boolean,
    totalPaginas: number,
    tamanoPaginaFiltro: number,
    maxRegistrosXLS: number,
    closeModalXLS: () => void;
    generarXLS: (pagina: number) => void;
}


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/inconsistencias/componentes/ModalXLSDatosGlosas.tsx